"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EncounterStartRequestSchema () {
        return EncounterStartRequestSchema;
    },
    get EncounterStartResponseSchema () {
        return EncounterStartResponseSchema;
    }
});
const _zod = require("zod");
const EncounterStartRequestSchema = _zod.z.object({
    patientId: _zod.z.string().uuid({
        message: 'patientId must be a UUID.'
    }),
    appointmentId: _zod.z.string().uuid({
        message: 'appointmentId must be a UUID.'
    }).optional()
}).strict();
const EncounterStartResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    resumed: _zod.z.boolean()
}).strict();
